var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"checkbox",style:({width: _vm.width, height: _vm.height}),attrs:{"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":function($event){$event.stopPropagation();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }